const samplingsTableColumns = [
  {
    key: 'images',
    label: 'Images',
    allowsSorting: false
  },
  {
    key: 'name',
    label: 'Name',
    allowsSorting: true
  },
  {
    key: 'type',
    label: 'Type',
    allowsSorting: true
  },
  {
    key: 'supplier_name',
    label: 'Supplier',
    allowsSorting: true
  },
  {
    key: 'stage',
    label: 'Stage',
    allowsSorting: true
  },
  {
    key: 'requested_at',
    label: 'Requested',
    allowsSorting: true
  },
  {
    key: 'completion_at',
    label: 'Completion',
    allowsSorting: true
  }
];

export default samplingsTableColumns;
